import { useContext, useState } from "react";
import CButton from "../../../../../components/buttons/Button";
import SuccessOtp from "./successOtp";
import WrongOtp from "./wrongOtp";
import { SignUpOtpHooks, SignUpResendHooks } from "../../hooks/useSignup";
import Cookies from "js-cookie";
import { LoadingContext } from "../../../../../context/loadingContext";
import { success } from "../../../../../components/alertMessagesHandler/alert";

const EnterOtp = (props) => {
  const { setLoading } = useContext(LoadingContext);
  const [errorMsg, setErrorMsg] = useState("");
  const [isValid, setIsValid] = useState("");
  const [flag, setFlag] = useState("");
  const [otpValue, setOtpValue] = useState("");

  const userEmail = Cookies.get("email");

  // Form validation and for displaying error message

  const getNumber = (num, len) => {
    if (Number.isInteger(num)) {
      setErrorMsg("");
      setIsValid("");
      if (len === 6) {
        setErrorMsg("");
        setIsValid("");
      }
      // else {
      //   setIsValid("is-invalid");
      //   setErrorMsg("Please enter 6 digit for otp");
      // }
    } else {
      setIsValid("is-invalid");
      setErrorMsg(`Please enter valid input`);
    }
  };

  // otp verification using SignUpOtpHooks

  const checkOtp = async () => {
    setLoading(true);
    const data = {
      email: userEmail,
      otp: otpValue,
    };
    const result = await SignUpOtpHooks(data);
    setLoading(false);
    if (result.status === 500) setFlag("0");
    else setFlag("1");
  };

  // Resend otp using SignUpResendHooks

  const ResendOtp = async () => {
    setLoading(true);
    const data = {
      email: userEmail,
    };
    const result = await SignUpResendHooks(data);
    setLoading(false);
    if (result.status === 200) success(result.message);
  };
  return (
    <>
      {/* {() => {
        if (flag === "1")
          return <SuccessOtp setOtp={(status) => props.setOtp(status)} />;
      }}
      () */}
      {flag === "1" ? (
        <SuccessOtp setOtp={(status) => props.setOtp(status)} />
      ) : flag === "0" ? (
        <WrongOtp setFlagZero={() => setFlag("")} />
      ) : (
        <div className="row py-5">
          <div className="col-md-4 col-sm-12"></div>
          <div
            className="col-md-4 col-sm-12 text-center mt-5"
            style={{ minHeight: "100vh" }}
          >
            <span className="text-dark mt-5 mb-5 fw-bolder">
              Enter the Verification code sent
            </span>
            <br></br>
            <span className="text-dark mb-5 fw-bolder">to your Email ID.</span>
            <div className="mt-4">
              <div className="otp-input-wrapper">
                <input
                  className={`${isValid}`}
                  type="text"
                  maxLength="6"
                  pattern="[0-9]*"
                  autocomplete="off"
                  onBlur={(event) => {
                    getNumber(
                      Number(event.target.value),
                      event.target.value.length
                    );
                  }}
                  onChange={(event) => {
                    setOtpValue(event.target.value);
                  }}
                />
                <svg viewBox="0 0 240 1" xmlns="http://www.w3.org/2000/svg">
                  <line
                    x1="0"
                    y1="0"
                    x2="240"
                    y2="0"
                    stroke="#3e3e3e"
                    stroke-width="2"
                    stroke-dasharray="30,10"
                  />
                </svg>
                <div className="invalid-feedback">{errorMsg}</div>
              </div>
            </div>
            <CButton
              btnClassesDiv={"text-center mt-5"}
              btnClasses={"btn px-4 fw-bold text-white mt-3"}
              IsOutline={false}
              innertext={"Submit"}
              btnCustomStyle={{
                backgroundColor: "#044389",
              }}
              functionName={() => checkOtp()}
            />
            <div className="mt-2" style={{ fontSize: "14px" }}>
              <CButton
                btnClassesDiv={"text-center"}
                btnClasses={
                  "btn bg-transparent text-primary border-0 text-decoration-underline"
                }
                IsOutline={false}
                innertext={"Resend verification code"}
                btnCustomStyle={{
                  backgroundColor: "#044389",
                }}
                functionName={() => ResendOtp()}
              />
            </div>
          </div>
          <div className="col-md-4 col-sm-12"></div>
        </div>
      )}
    </>
  );
};

export default EnterOtp;
